<div id="<%= dom_id score %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Judge:</strong>
    <%= score.judge_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Heat:</strong>
    <%= score.heat_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Person:</strong>
    <%= score.person_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Value:</strong>
    <%= score.value %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Good:</strong>
    <%= score.good %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Bad:</strong>
    <%= score.bad %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Comments:</strong>
    <%= score.comments %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Slot:</strong>
    <%= score.slot %>
  </div>
</div>
